module.exports = __webpack_public_path__ + "img/marco_n.8f05d960.png";